module.exports = __webpack_public_path__ + "img/ico5.14ade38a.svg";